'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileUploadsErrors = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFileUploadsErrors = exports.getFileUploadsErrors = (0, _get2.default)('fileUploadsErrors');


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/selectors/getFileUploadsErrors.js
// module id = 653
// module chunks = 2 3